export const FALLBACK_PRODUCT_IMAGE_SRC = 'assets/images/fallback-product-image.png';
